import React from "react";

const Gallery = () => {
    return (
        <div>
            <h1>Gallery</h1>
            <p>View our collection of images and projects.</p>
        </div>
    );
};

export default Gallery;
